import {initialState} from "./state";
import axios from "axios";

let source = null;
let REQUEST_SEQUENCE = 0;

export default {

    resetSate({commit}) {
        const state = initialState();
        commit('RESET_STATE', state);
    },

    // updateSearch({commit}, value) {
    //     commit('UPDATE_SE')
    // },

    updateOptions({commit}, options) {
        commit('UPDATE_OPTIONS', options);
    },

    updateFacets({commit}, facets) {
        commit('UPDATE_FACETS', facets);
    },

    updateFilter({ dispatch, commit }, payload) {
        commit('UPDATE_FILTER', payload);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    removeFilter({ dispatch, commit }, taxonomy) {
        commit('REMOVE_FILTER', taxonomy);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    addFilterDuration({ dispatch, commit }, duration) {
        commit('ADD_FILTER_DURATION', duration);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    removeFilterDuration({ dispatch, commit }, duration) {
        commit('REMOVE_FILTER_DURATION', duration);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    addFilterTerm({ dispatch, commit }, payload) {
        commit('ADD_FILTER_TERM', payload);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    removeFilterTerm({ dispatch, commit }, payload) {
        commit('REMOVE_FILTER_TERM', payload);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    updateSort({ dispatch, commit }, payload) {
        commit('UPDATE_SORT', payload);
        commit('SET_PAGE', 1);
        return dispatch('fetchData');
    },

    updateRenderType({ dispatch, commit }, renderType) {
        commit('UPDATE_RENDER_TYPE', renderType);
        return dispatch('fetchData');
    },

    setPage({dispatch, commit}, page) {
        commit('SET_PAGE_NUM', page);

        return dispatch('fetchData');
    },

    fetchData({state, commit}) {
        if (source) {
            source.cancel();
        }
        source = axios.CancelToken.source();
        const { filter, sort, paged } = state;
        const params = {
            filter,
            sort,
            page_num: paged.page_num,
            page_size: paged.page_size,
            seq: ++REQUEST_SEQUENCE
        };
        commit('SET_BUSY_STATE', true);
        return axios
            .get(state.options.url, {
                cancelToken: source.token,
                params
            })
            .then(response => {
                //console.log(response.data);
                source = null;
                commit('SET_BUSY_STATE', false);

                if (response.data.success) {

                    const result = response.data.data;
                    if (result.seq && parseInt(result.seq) < REQUEST_SEQUENCE) {
                        // keep request sequence in order, so skip older requests
                        return;
                    }
                    if (result.html) {
                        commit('UPDATE_HTML', result.html);
                    }
                    if (result.meta) {
                        const paged = result.meta.paged;
                        commit('UPDATE_PAGED', paged);
                        const facets = result.meta;
                        delete facets.paged;
                        commit('UPDATE_FACETS', facets);
                    }
                } else {
                    //commit('SET_ERROR', response.data.data)
                }
            })
            .catch(err => {
                source = null;
                if (!axios.isCancel(err)) {
                    commit('SET_BUSY_STATE', false);
                    console.log('Request error: ', err);
                }
            });
    }

};
